import React, { useEffect, useState } from 'react'
import ChannelInChannelList from './ChannelInChannelList';
import CreateNewChannelModal from '../Channel/CreateNewChannelModal';
import { useDispatch, useSelector } from 'react-redux';
import { getChannelListThunk } from '../../slices/userSlice';
import { PlusIcon, SearchIcon } from '../../utils/icons';
import SimpleLoading from '../LoadingComponent/SimpleLoading';

const ChannelLists = ({ handleSelectionChange }) => {
    const dispatch = useDispatch();
    const [createChannelModal, setCreateChannelModal] = useState(false);
    const userChannelList = useSelector((state) => state.user.userChannelList) || [];
    const [channelLoading, setChannelLoading] = useState(false);
    const [filteredChannel, setFilteredChannel] = useState(userChannelList);

    useEffect(()=>{
      setFilteredChannel(userChannelList)
    }, [userChannelList])

    useEffect(()=>{
        if(userChannelList?.length === 0){
            setChannelLoading(true);
            dispatch(getChannelListThunk()).unwrap()
            .then(res => {
                console.log(res, " === getChannelListThunk ===");
                setFilteredChannel(res);
                setChannelLoading(false)
            })
            .catch(err => setChannelLoading(false));
        }
    }, [])

    const handleAddNewChannel = (e) => {
        e.stopPropagation();
        console.log("create channel");
        setCreateChannelModal(true);
    };
    
    const handleSearchChannel = (e) => {
      const value = e.target.value?.toLocaleLowerCase();
      console.log(value, "handleSearchChannel");
      const filteredChannel = userChannelList?.filter(channel => channel?.channelDetails?.ChannelName?.toLocaleLowerCase()?.includes(value));
      setFilteredChannel(filteredChannel);
    }

  return (
        <>
          <CreateNewChannelModal isShow={createChannelModal} closeModal={()=>setCreateChannelModal(false)} />
          <div className='min-w-[230px] w-[25%] mr-1 rounded-3xl p-2 pb-3 shadow-chatBoxShadow overflow-hidden'>
            <div className="flex items-center justify-between bg-pureWhite p-1 mb-2">
              <p>Channel List</p>
              <span className='cursor-pointer' onClick={handleAddNewChannel}><PlusIcon className="plus-icon" /></span>
            </div>
            <div className="flex items-center bg-pureWhite p-1 border-2 border-gray-300 rounded-lg mb-2">
              <input placeholder="Search Channel" className="outline-none w-[90%] pl-1 pr-3" onChange={handleSearchChannel} />
              <span className='w-[10%] h-4'><SearchIcon /></span>
            </div>
            <div className='max-h-full pb-16 overflow-y-auto'>
              {channelLoading ? <div className='ml-6'><SimpleLoading /></div> 
              : 
              filteredChannel?.length > 0 ? filteredChannel?.map((channel, i) => {
                return (
                  <ChannelInChannelList key={i} channel={channel} onClick={() => handleSelectionChange({ ...channel, type: "channel",})} />
                );
              }): <p className='text-gray-600 text-center'>No Channel</p>}
            </div>
          </div>
        </>
    );
}

export default ChannelLists
